<script setup lang="ts">
import { computed } from 'vue'
import { storeToRefs } from 'pinia'
import { useHead } from '@unhead/vue'

import { usePageStore } from '../../../stores/page'
import { useDeviceDetection } from '../../../composables/use-device-detection'
import { useCdnImages } from '../../../composables/use-cdn-images'

import type { ReactiveHead } from '@unhead/vue'

const { pageData } = storeToRefs(usePageStore())
const { hasMobileAds, isTablet } = useDeviceDetection()
const { cdnImageUrl } = useCdnImages()

useHead(computed<ReactiveHead>(() => {
  if (!pageData.value) return {}

  const url = `${pageData.value.pageMeta.baseUrl}${pageData.value.pageMeta.url}`
  const smartbannerMetas = [
    { name: 'smartbanner:title', content: 'Lecker - Rezepte für jeden Tag' },
    { name: 'smartbanner:author', content: 'BAUER XCEL MEDIA DEUTSCHLAND KG' },
    { name: 'smartbanner:price', content: 'FREE' },
    { name: 'smartbanner:price-suffix-google', content: ' - In Google Play' },
    { name: 'smartbanner:icon-google', content: 'https://play-lh.googleusercontent.com/kBYWLsuhl9H6LS7iOB3TQU1Hj6jgzYSZYUeH3-_15bsFmydbHP1nBRE8SOyGm23c1AE=w240-h480-rw' },
    { name: 'smartbanner:button', content: 'VIEW' },
    { name: 'smartbanner:button-url-google', content: 'http://play.google.com/store/apps/details?id=com.bauermedia.leckertagesrezepte' },
    { name: 'smartbanner:enabled-platforms', content: 'android' },
    { name: 'smartbanner:close-label', content: 'Close' }
  ]

  const disableWhileLookingForContentShiftSolution = true
  const showSmartbanner = !import.meta.env.SSR &&
    !disableWhileLookingForContentShiftSolution && (hasMobileAds.value || isTablet.value)

  return {
    script: showSmartbanner
      ? [{ name: 'smart-app-banner', src: '/js/lecker/smartbanner.min.js' }]
      : [],
    link: showSmartbanner
      ? [{ rel: 'stylesheet', href: '/css/lecker/smartbanner.min.css', key: 'smartbanner' }]
      : [],
    meta: import.meta.env.SSR
      ? []
      : [
        ...(showSmartbanner ? smartbannerMetas : []),
        { name: 'apple-itunes-app', content: `app-id=545648266, app-argument=${url}` }
      ]
  }
}))
</script>

<template>
  <a class="bx-header__logo"
     title="LECKER.de"
     href="/">
    <img :src="cdnImageUrl('/images/lecker/lecker-logo-white.svg')"
         alt="LECKER Logo"
         width="211"
         height="80">
  </a>
</template>
